import {CommentIcon} from '@primer/octicons-react'
import {ActionList, CounterLabel} from '@primer/react'
import {Link, useLocation} from '@github-ui/react-router'
import type {CatchUpTimelineEvent} from '@github-ui/dotcom-schema/types/pull_requests/v1/activity'
import {useSuspenseActivityPageData} from '../../data/use-activity-page-data'
import {hasIssueComments} from './activity-row-helpers'
import {issueCommentAnchor} from '../../../comments/utils/comment-anchors'
import {OVERVIEW_COMMENTS_ANCHOR_ID} from '../../../../helpers/constants'
import styles from '../ActivityRows.module.css'

export function IssueCommentsRow() {
  const {summary} = useSuspenseActivityPageData()
  const {pathname} = useLocation()
  if (!hasIssueComments(summary)) return null

  const n = summary?.issueComments?.count ?? 0
  const oldest = summary?.issueComments?.events.reduce<CatchUpTimelineEvent | undefined>(
    (first, event) => (!first || Date.parse(event.timestamp) < Date.parse(first.timestamp) ? event : first),
    undefined,
  )
  const info = oldest?.additionalInfo?.info
  const commentId = info?.case === 'issueComment' ? info.value.commentId : undefined
  const hash = commentId ? issueCommentAnchor(commentId.toString()) : OVERVIEW_COMMENTS_ANCHOR_ID

  return (
    <ActionList.LinkItem as={Link} to={{pathname, search: '', hash}} className={styles.labelRow}>
      <ActionList.LeadingVisual>
        <CommentIcon />
      </ActionList.LeadingVisual>
      Comments
      <ActionList.TrailingVisual className={styles.count}>
        <CounterLabel>{n}</CounterLabel>
      </ActionList.TrailingVisual>
    </ActionList.LinkItem>
  )
}
